// XXX only reason to have this is to have the pair as key-able react list map result node
import {
  ClickablePathItem,
  NonClickablePathItem,
} from './SelectCdwTableFormUI';
import React from 'react';

interface IProps {
  pathComponentName: string;
  ix: number;
  openParent: (ix: number) => void;
}

export const ClickablePathItemPair = ({
  pathComponentName,
  ix,
  openParent,
}: IProps) => (
  <>
    <ClickablePathItem onClick={() => openParent(ix)}>
      {pathComponentName}
    </ClickablePathItem>
    <NonClickablePathItem>&gt;</NonClickablePathItem>
  </>
);
